import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);

import router from './router'

import PageContent from './components/page-content'
import PageRow from './components/page-row'
Vue.component(PageContent.name, PageContent)
Vue.component(PageRow.name, PageRow)

import { default as Modals, Modal } from 'src'
Vue.use(Modals)
Vue.component(Modal.name, Modal)

import "highlight.js/styles/agate.css"
import VueHighlightJS from 'vue-highlightjs'

// Tell Vue.js to use vue-highlightjs
Vue.use(VueHighlightJS)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: (h) => h(App)
})



// WEBPACK FOOTER //
// ./demo/main.js